var Cortona3DSolo = require('solo');
var app = require('app').app;
var util = require('lib/util');

var m_hoverRow = -1;

var DOUBLE_TAP_TIME = 250;
var PRESS_TIME = 750;

var ipcExports = {
    /**
     * The namespace represents an application interface to manage DPL table in the interactive parts catalog.
     * 
     * @namespace
     * @memberof module:solo.app.ipc
     */
    dpl: {

        /**
         * Setup the DPL table for the current IPC sheet.
         * 
         * @param {HTMLTableElement} dplTableElement An HTML table representing the current IPC sheet
         * @see external:HTMLTableElement
         * @fires "app.ipc.dpl.didSetupRow"
         * @fires "app.ipc.dpl.willSetupTable"
         * @fires "app.ipc.dpl.didSetupTable"
         */
        setupTable: function (dplTableElement) {
            Cortona3DSolo.dispatch('app.ipc.dpl.willSetupTable', dplTableElement);
            if (dplTableElement) {
                m_hoverRow = -1;

                // TO-DO: touch devices
                // TO-DO: keyboard accelerators

                var timeoutOut,
                    indexOut;

                var contextMenuHandler = function (e) {
                    var index = +this.getAttribute('data-index');
                    var target = dplTableElement,
                        rect = target.getBoundingClientRect(),
                        offsetX = e.clientX - rect.left,
                        offsetY = e.clientY - rect.top;
                    Cortona3DSolo.dispatch("app.ipc.dpl.didCallContextMenu", index, offsetX, offsetY, target);
                };

                Array.prototype.slice.call(dplTableElement.rows).forEach(function (row) {
                    if (row.id) {
                        var index = +row.id.substring(3);
                        row.setAttribute('data-index', index);
                        row.onmouseover = function (e) {
                            clearTimeout(timeoutOut);
                            var index = +this.getAttribute('data-index');
                            if (indexOut !== index) {
                                indexOut = null;
                                Cortona3DSolo.dispatch("app.ipc.dpl.didHoverRow", index);
                            }
                        };
                        row.onmouseout = function (e) {
                            indexOut = +this.getAttribute('data-index');
                            clearTimeout(timeoutOut);
                            timeoutOut = setTimeout(function () {
                                Cortona3DSolo.dispatch("app.ipc.dpl.didHoverRow", -1);
                                indexOut = null;
                            }, 10);
                        };
                        row.onclick = function (e) {
                            var index = +this.getAttribute('data-index');
                            var keys = +(e.shiftKey && 1) | +(e.ctrlKey && 2) | +(e.altKey && 4);
                            var self = this;
                            if (!this.__debounceTimeout) {
                                this.__debounceTimeout = setTimeout(function () {
                                        delete self.__debounceTimeout;
                                        Cortona3DSolo.dispatch("app.ipc.dpl.didSelectRow", index, keys);
                                    },
                                    DOUBLE_TAP_TIME);
                            } else {
                                clearTimeout(this.__debounceTimeout);
                                delete this.__debounceTimeout;
                            }
                        };
                        row.oncontextmenu = function (e) {
                            if (e.preventDefault) e.preventDefault();
                            if (e.stopPropagation) e.stopPropagation();
                            if (this.__pointerDown) return;
                            contextMenuHandler.call(this, e);
                        };
                        row.onpointerdown = function (e) { 
                            if (e.pointerType == 'mouse' || !e.isPrimary) return;
                            this.__pointerDown = true;
                            this.__pressTimeout = setTimeout((function () {
                                delete this.__pressTimeout;
                                contextMenuHandler.call(this, e);
                            }).bind(this), PRESS_TIME);
                        }
                        row.onpointerout = function (e) { 
                            if (e.pointerType == 'mouse' || !e.isPrimary) return;
                            clearTimeout(this.__pressTimeout);
                            delete this.__pressTimeout;
                            setTimeout((function () {
                                delete this.__pointerDown;
                            }).bind(this), 100);
                        }
                        Cortona3DSolo.dispatch("app.ipc.dpl.didSetupRow", row, index);
                    }
                });
            }
            Cortona3DSolo.dispatch('app.ipc.dpl.didSetupTable', dplTableElement);
        },
        /**
         * Highlight the line in the DPL table.
         * 
         * @param {number} index The row number on the current IPC sheet
         */
        hoverRow: function (index) {
            var el;
            if (m_hoverRow >= 0) {
                el = document.getElementById('row' + m_hoverRow);
                if (el) el.classList.remove('hover');
            }
            if (index >= 0) {
                el = document.getElementById('row' + index);
                if (el) el.classList.add('hover');
            }
            m_hoverRow = index;
        },
        /**
         * Highlight the line in the DPL table.
         * 
         * @param {number} index The row number on the current IPC sheet
         * @param {boolean} [flag=true] -
         * - true - highlight the DPL table row
         * - false - clear selection
         */
        highlightRow: function (index, flag) {
            flag = (typeof flag == 'undefined') ? true : flag;
            util.toggleClass(document.getElementById('row' + index), 'hover', flag);
        },
        /**
         * Select the line in the DPL table.
         * 
         * @param {number} index The row number on the current IPC sheet
         * @param {boolean} [flag=true] -
         * - true - select the DPL table row
         * - false - clear selection
         */
        selectRow: function (index, flag) {
            flag = (typeof flag == 'undefined') ? true : flag;
            util.toggleClass(document.getElementById('row' + index), 'selected', flag);
        },
        /**
         * Toggles the line in the DPL table.
         * 
         * @param {number} index The row number on the current IPC sheet
         * @param {boolean} [flag] -
         * - true - make the DPL table row visible
         * - false - make the DPL table row hidden
         * @since 1.4.3
         */
        toggleRow: function (index, flag) {
            var el = document.getElementById('row' + index);
            if (el) {
                flag = (typeof flag == 'undefined') ? el.classList.contains('hidden') : flag;
                util.toggleClass(el, 'hidden', !flag);
            }
        },
    }
};

module.exports = ipcExports.dpl;

/**
 * The hook method is invoked before the DPL table is initialized.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function willSetupTable
 * @param {HTMLTableElement} tableElement The table element
 * @see external:HTMLTableElement
 * @see The corresponding event {@link event:"app.ipc.dpl.willSetupTable" "app.ipc.dpl.willSetupTable"}
 * @since 1.5.0
 */
/**
 * @event "app.ipc.dpl.willSetupTable"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.willSetupTable app.ipc.dpl.willSetupTable()}
 */

/**
 * The hook method is invoked after the DPL table is initialized.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function didSetupTable
 * @param {HTMLTableElement} tableElement The table element
 * @see external:HTMLTableElement
 * @see The corresponding event {@link event:"app.ipc.dpl.didSetupTable" "app.ipc.dpl.didSetupTable"}
 * @since 1.5.0
 */
/**
 * @event "app.ipc.dpl.didSetupTable"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.didSetupTable app.ipc.dpl.didSetupTable()}
 */

/**
 * The hook method is invoked when the line of the DPL table is initialized.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function didSetupRow
 * @param {HTMLTableRowElement} rowElement The row element
 * @param {number} index The row number in the DPL table
 * @see external:HTMLTableRowElement
 * @see The corresponding event {@link event:"app.ipc.dpl.didSetupRow" "app.ipc.dpl.didSetupRow"}
 */
/**
 * @event "app.ipc.dpl.didSetupRow"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.didSetupRow app.ipc.dpl.didSetupRow()}
 */

/**
 * The hook method is invoked when the line of the DPL table is selected.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function didSelectRow
 * @param {number} index The row number on the current IPC sheet
 * @param {number} keys Flags bitmask that corresponds to the state of the SHIFT, CTRL, and ALT keys:
 * - 0x01 - SHIFT key
 * - 0x02 - CTRL key
 * - 0x04 - ALT key
 * @see The corresponding event {@link event:"app.ipc.dpl.didSelectRow" "app.ipc.dpl.didSelectRow"}
 */
/**
 * @event "app.ipc.dpl.didSelectRow"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.didSelectRow app.ipc.dpl.didSelectRow()}
 */

/**
 * The hook method is invoked when the line of the DPL table is hovered.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function didHoverRow
 * @param {number} index The row number on the current IPC sheet
 * @see The corresponding event {@link event:"app.ipc.dpl.didHoverRow" "app.ipc.dpl.didHoverRow"}
 */
/**
 * @event "app.ipc.dpl.didHoverRow"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.didHoverRow app.ipc.dpl.didHoverRow()}
 */

/**
 * The hook method is invoked when the context menu is called in the DPL table. 
 * The mouse uses secondary button click. The touch device uses long tap.
 * 
 * @memberof module:solo.app.ipc.dpl
 * @abstract 
 * @function didCallContextMenu
 * @param {number} index The row number on the current IPC sheet
 * @param {number} offsetX The X coordinate relative to the target element
 * @param {number} offsetY The Y coordinate relative to the target element 
 * @param {HTMLElement} target Target element (`<table>`)
 * @see The corresponding event {@link event:"app.ipc.dpl.didCallContextMenu" "app.ipc.dpl.didCallContextMenu"}
 */
/**
 * @event "app.ipc.dpl.didCallContextMenu"
 * @see The corresponding hook method {@link module:solo.app.ipc.dpl.didCallContextMenu app.ipc.dpl.didCallContextMenu()}
 */